import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useDebounce } from "hooks/useDebounce";

export const useMedicationsSearch = (search = "", isManual = false) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");
  const debouncedSearch = useDebounce(search, 400);

  return useQuery({
    queryKey: ["medications", debouncedSearch, tenantVal],
    queryFn: async () => {
      if (!debouncedSearch) return [];
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/drugsfile/search/${debouncedSearch.replace(/\//g, "-")}`
      );
      return response.data;
    },
    enabled: !isManual && debouncedSearch.length > 2,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
